import { render, staticRenderFns } from "./Conversas.vue?vue&type=template&id=7c207a04&scoped=true"
import script from "./Conversas.vue?vue&type=script&lang=js"
export * from "./Conversas.vue?vue&type=script&lang=js"
import style0 from "./Conversas.vue?vue&type=style&index=0&id=7c207a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c207a04",
  null
  
)

export default component.exports